<template>
    <b-form-tags
      id="tags-with-lookup"
      v-model="selectedIds"
      no-outer-focus
      class="mb-2"
    >
      <template #default="{ tags, disabled, addTag, removeTag }">
        <!-- tags === selectedIds -->
        <ul v-if="tags.length" class="list-inline d-inline-block mb-2">
          <li
            v-for="id in tags"
            :key="id"
            class="list-inline-item"
          >
            <b-form-tag
              :title="optionById(id).name"
              :disabled="disabled"
              variant="info"
              @remove="removeTag(id)"
            >
              {{ optionById(id).tag }}
            </b-form-tag>
          </li>
        </ul>

        <!-- Lookup dropdown -->
        <b-dropdown
          size="sm"
          variant="outline-secondary"
          block
          no-flip
          menu-class="w-100"
          :disabled="disabled"
        >
          <template #button-content>
            Add tag
          </template>

          <!-- Search box -->
          <b-dropdown-form @submit.stop.prevent>
            <b-form-group
              label="Search tags"
              label-for="tag-search-input"
              label-cols-md="auto"
              class="mb-0"
              label-size="sm"
              :disabled="disabled"
            >
              <b-form-input
                id="tag-search-input"
                v-model="search"
                type="search"
                size="sm"
                autocomplete="off"
              />
            </b-form-group>
          </b-dropdown-form>

          <b-dropdown-divider />

          <b-dropdown-item-button
            v-for="option in filteredOptions"
            :key="option.id"
            @click="onOptionClick(option.id, addTag)"
          >
            {{ option.tag }}
            <small class="text-muted ml-1">
              ({{ option.name }})
            </small>
          </b-dropdown-item-button>

          <b-dropdown-text v-if="moreResultsCount">
            <small class="text-muted">
              +{{ moreResultsCount }} more results, type to narrow
            </small>
          </b-dropdown-text>

          <b-dropdown-text v-else-if="noResultsText">
            <small class="text-muted">{{ noResultsText }}</small>
          </b-dropdown-text>
        </b-dropdown>
      </template>
    </b-form-tags>
</template>

<script>
export default {
  name: 'tag-field',
  props: {
    tagList: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      search: '',
      maxResults: 5,
    }
  },
  computed: {
    selectedIds: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    optionsById() {
      const map = {}
      for (const opt of this.tagList) {
        map[String(opt.id)] = opt
      }
      return map
    },

    // For your own convenience if you need full objects
    selectedObjects() {
      const selectedSet = new Set(this.selectedIds.map(String))
      return this.tagList.filter(opt => selectedSet.has(String(opt.id)))
    },

    criteria() {
      return this.search.trim().toLowerCase()
    },

    filteredOptions() {
      const criteria = this.criteria
      const selectedSet = new Set(this.selectedIds.map(String))

      const matches = this.tagList.filter(opt => {
        const idStr = String(opt.id)

        // exclude already-selected IDs
        if (selectedSet.has(idStr)) return false

        if (!criteria) return true

        return (
          opt.name.toLowerCase().includes(criteria) ||
          opt.tag.toLowerCase().includes(criteria)
        )
      })

      // HARD LIMIT: only show first N results in the dropdown
      return matches.slice(0, this.maxResults)
    },

    moreResultsCount() {
      const criteria = this.criteria
      const selectedSet = new Set(this.selectedIds.map(String))

      const total = this.tagList.filter(opt => {
        const idStr = String(opt.id)
        if (selectedSet.has(idStr)) return false

        if (!criteria) return true

        return (
          opt.name.toLowerCase().includes(criteria) ||
          opt.tag.toLowerCase().includes(criteria)
        )
      }).length

      return Math.max(0, total - this.maxResults)
    },

    noResultsText() {
      if (!this.filteredOptions.length) {
        return this.criteria
          ? 'No tags match your search'
          : 'All available tags are already selected'
      }
      return ''
    }
  },
  methods: {
    optionById(id) {
      const idStr = String(id)
      return this.optionsById[idStr] || { name: idStr, tag: '' }
    },
    onOptionClick(id, addTag) {
      addTag(String(id))
      this.search = ''
    }
  },

}
</script>
